import { tblSpecAddColumn } from '../../../core/table/spec';
import { TblCol } from '../../../core/table/table.types';
import { TblViewSpec } from '../../../core/table/table-view.types';

export type ColKey =
    | ''
    | 'LineNum'
    | 'VendorItemNum'
    | 'NDC'
    | 'VendorItemName'
    | 'DrugInfo'
    | 'Overallocated'
    | 'PackagesShipped'
    | 'PricePerPackage'
    | 'Amount'
    | 'NdcOptimized'
    | 'IsRebate'
    | 'BackingTxt';

export function splitOrderInvoiceLineItemsColumnSpec(): Map<string, TblCol> {
    const map = new Map<ColKey, TblCol>();
    tblSpecAddColumn<ColKey>(map, 'LineNum', { title: 'Line #', type: 'TEXT' });
    tblSpecAddColumn<ColKey>(map, 'VendorItemNum', { title: 'Item Number', type: 'TEXT' });
    tblSpecAddColumn<ColKey>(map, 'NDC', { title: 'NDC', type: 'TEXT' });
    tblSpecAddColumn<ColKey>(map, 'VendorItemName', { title: 'Vendor Item Name', type: 'TEXT' });
    tblSpecAddColumn<ColKey>(map, 'DrugInfo', { title: 'Drug Info', type: 'TEXT' });
    tblSpecAddColumn<ColKey>(map, 'Overallocated', { title: 'Over Allocated', type: 'TEXT' });
    tblSpecAddColumn<ColKey>(map, 'PackagesShipped', { title: 'Packages Shipped', type: 'TEXT' });
    tblSpecAddColumn<ColKey>(map, 'PricePerPackage', { title: 'Per Package', type: 'TEXT' });
    tblSpecAddColumn<ColKey>(map, 'Amount', { title: 'Total Price', type: 'TEXT' });
    tblSpecAddColumn<ColKey>(map, 'NdcOptimized', { title: 'NDC Optimized', type: 'TEXT' });
    tblSpecAddColumn<ColKey>(map, 'IsRebate', { title: 'Rebate', type: 'TEXT' });
    tblSpecAddColumn<ColKey>(map, 'BackingTxt', { title: 'Dispense Backing', type: 'TEXT' });
    return map;
}

export function splitOrderInvoiceLineItemsAllColumnsView(): TblViewSpec {
    return {
        key: 'all',
        title: 'All Columns',
        sections: [
            { title: 'Vendor Invoice', cols: ['LineNum', 'VendorItemNum'] },
            { title: 'Drug Info', cols: ['NDC', 'VendorItemName', 'Overallocated', 'NdcOptimized'] },
            { title: 'Qty', cols: ['PackagesShipped'] },
            { title: 'Invoice Pricing', cols: ['PricePerPackage', 'Amount'] },
            { title: 'Details', cols: ['BackingTxt', 'IsRebate'] },
        ],
        sortby: 'LineNum',
    };
}

export function splitOrderInvoiceLineItemsOptionalColumnsView(
    showOverallocated: boolean,
    showNdcOptimized: boolean,
    showRebate: boolean,
    showBacking: boolean = true,
): TblViewSpec {
    const drugInfoCols = ['NDC', 'VendorItemName'];
    if (showOverallocated) drugInfoCols.push('Overallocated');
    if (showNdcOptimized) drugInfoCols.push('NdcOptimized');

    const detailsCols: string[] = [];
    if (showBacking) detailsCols.push('BackingTxt');
    if (showRebate) detailsCols.push('IsRebate');

    const sections = [
        { title: 'Vendor Invoice', cols: ['LineNum', 'VendorItemNum'] },
        { title: 'Drug Info', cols: drugInfoCols },
        { title: 'Qty', cols: ['PackagesShipped'] },
        { title: 'Invoice Pricing', cols: ['PricePerPackage', 'Amount'] },
        ...(detailsCols.length > 0 ? [{ title: 'Details', cols: detailsCols }] : []),
    ];

    return {
        key: 'optional-cols',
        title: 'All Columns',
        sections,
        sortby: 'LineNum',
    };
}
